(() => {
  if (window.sxProductExperience) return;
  window.sxProductExperience = true;
  const config = document.querySelector('[data-sx-messages]');
  if (!config) return;
  const messages = config.dataset;
  const key = 'spheresx.wishlist.v1';
  const drawer = document.getElementById('sx-wishlist');
  const shareDialog = document.getElementById('sx-share');
  const list = drawer.querySelector('[data-sx-list]');
  const toast = document.querySelector('[data-sx-toast]');
  let toastTimer;
  let opener;
  let items = [];
  const productURL = value => {
    try {
      const url = new URL(value, window.location.origin);
      if (url.origin !== window.location.origin || !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/[a-z0-9-]+\/?$/i.test(url.pathname)) return null;
      url.search = '';
      url.hash = '';
      return url;
    } catch { return null; }
  };
  const imageURL = value => {
    try {
      const url = new URL(value, window.location.origin);
      if (url.protocol !== 'https:') return '';
      if (url.origin !== window.location.origin && url.hostname !== 'cdn.shopify.com') return '';
      return url.href;
    } catch { return ''; }
  };
  const read = () => {
    try {
      const stored = JSON.parse(localStorage.getItem(key) || '[]');
      if (!Array.isArray(stored)) return [];
      const unique = new Set();
      return stored.filter(item => item && typeof item.id === 'string' && /^\d+$/.test(item.id) && typeof item.title === 'string' && typeof item.url === 'string' && productURL(item.url) && !unique.has(item.id) && unique.add(item.id)).slice(0, 100).map(item => ({id:item.id,title:item.title.slice(0,250),url:productURL(item.url).pathname,image:imageURL(item.image)}));
    } catch { return []; }
  };
  const notify = text => {
    clearTimeout(toastTimer);
    toast.textContent = text;
    toast.hidden = false;
    toastTimer = setTimeout(() => { toast.hidden = true; }, 3500);
  };
  const close = dialog => { dialog.close(); if (opener?.isConnected) opener.focus(); };
  const open = (dialog, button) => {
    opener = button;
    if (!dialog.open) dialog.showModal();
  };
  const render = () => {
    document.querySelectorAll('[data-sx-save]').forEach(button => {
      const saved = items.some(item => item.id === button.dataset.productId);
      button.setAttribute('aria-pressed', String(saved));
      button.setAttribute('aria-label', saved ? messages.remove : messages.save);
      const label = button.querySelector('[data-sx-save-label]');
      if (label) label.textContent = saved ? messages.saved : messages.save;
    });
    document.querySelectorAll('[data-sx-count]').forEach(count => {count.textContent=String(items.length);count.hidden=!items.length;});
    drawer.querySelector('[data-sx-empty]').hidden = !!items.length;
    list.replaceChildren();
    items.forEach(item => {
      const li=document.createElement('li');
      const a=document.createElement('a');a.href=item.url;
      if (item.image) {const img=document.createElement('img');img.src=item.image;img.alt='';img.width=64;img.height=64;img.loading='lazy';a.append(img);}
      const title=document.createElement('span');title.textContent=item.title;a.append(title);
      const remove=document.createElement('button');remove.type='button';remove.dataset.sxRemove=item.id;remove.setAttribute('aria-label',messages.remove+': '+item.title);remove.textContent='×';
      li.append(a,remove);list.append(li);
    });
  };
  const persist = next => {
    try {localStorage.setItem(key,JSON.stringify(next));items=next;render();return true;}
    catch {notify(messages.storageError);return false;}
  };
  const shareFallback = (button,url,title) => {
    shareDialog.querySelector('input').value=url;
    shareDialog.querySelector('[data-sx-copy-status]').textContent='';
    shareDialog.querySelector('[data-sx-whatsapp]').href='https://wa.me/?text='+encodeURIComponent(title+' '+url);
    open(shareDialog,button);
  };
  document.addEventListener('click', async event => {
    const button=event.target.closest('[data-sx-save],[data-sx-open],[data-sx-close],[data-sx-remove],[data-sx-share],[data-sx-copy],[data-sx-native]');
    if (!button) return;
    event.preventDefault();
    if (button.matches('[data-sx-save]')) {
      items=read();
      const exists=items.some(item=>item.id===button.dataset.productId);
      if (!exists && items.length>=100) {notify(messages.full);return;}
      const url=productURL(button.dataset.url);
      if (!url) return;
      const next=exists?items.filter(item=>item.id!==button.dataset.productId):[...items,{id:button.dataset.productId,title:button.dataset.title.slice(0,250),url:url.pathname,image:imageURL(button.dataset.image)}];
      if(persist(next)) notify(exists?messages.removed:messages.added);
    } else if(button.matches('[data-sx-open]')) {items=read();render();open(drawer,button);}
    else if(button.matches('[data-sx-close]')) close(button.closest('dialog'));
    else if(button.matches('[data-sx-remove]')) {
      items=read();const position=items.findIndex(item=>item.id===button.dataset.sxRemove);
      if(persist(items.filter(item=>item.id!==button.dataset.sxRemove))){notify(messages.removed);(list.querySelectorAll('[data-sx-remove]')[Math.max(0,position-1)]||drawer.querySelector('[data-sx-close]')).focus();}
    } else if(button.matches('[data-sx-share]')) {
      const url=productURL(button.dataset.url);if(!url)return;
      const selected=new URLSearchParams(location.search).get('variant');
      if(selected && /^\d+$/.test(selected))url.searchParams.set('variant',selected);
      shareFallback(button,url.href,button.dataset.title);
      shareDialog.dataset.title=button.dataset.title;
    } else if(button.matches('[data-sx-native]')) {
      try {await navigator.share({title:shareDialog.dataset.title,url:shareDialog.querySelector('input').value});}
      catch(error){if(error.name!=='AbortError')shareDialog.querySelector('[data-sx-copy-status]').textContent=messages.copyError;}
    } else if(button.matches('[data-sx-copy]')) {
      const input=shareDialog.querySelector('input');
      try {await navigator.clipboard.writeText(input.value);shareDialog.querySelector('[data-sx-copy-status]').textContent=messages.copied;}
      catch {input.focus();input.select();shareDialog.querySelector('[data-sx-copy-status]').textContent=messages.copyError;}
    }
  });
  [drawer,shareDialog].forEach(dialog=>{
    dialog.addEventListener('click',event=>{if(event.target===dialog){const rect=dialog.getBoundingClientRect();if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)close(dialog);}});
    dialog.addEventListener('cancel',event=>{event.preventDefault();close(dialog);});
  });
  window.addEventListener('storage',event=>{if(event.key===key||event.key===null){items=read();render();}});
  document.addEventListener('shopify:section:load',render);
  new MutationObserver(records => {if(records.some(record=>Array.from(record.addedNodes).some(node=>node.nodeType===1&&(node.matches('[data-sx-save]')||node.querySelector('[data-sx-save]')))))render();}).observe(document.body,{childList:true,subtree:true});
  if (typeof subscribe==='function' && typeof PUB_SUB_EVENTS!=='undefined') subscribe(PUB_SUB_EVENTS.variantChange,render);
  class SxSaleCountdown extends HTMLElement {
    connectedCallback() {
      this.hidden=true;
      const value=this.dataset.end||'';
      if(!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(?::\d{2})?(?:Z|[+-]\d{2}:\d{2})$/.test(value))return;
      this.deadline=Date.parse(value);
      if(!Number.isFinite(this.deadline)||this.deadline<=Date.now())return;
      const date=new Intl.DateTimeFormat(messages.locale||'en',{dateStyle:'medium',timeStyle:'short',timeZone:'Asia/Karachi'}).format(new Date(this.deadline));
      this.querySelector('[data-end-label]').textContent=messages.ends+' '+date+' (PKT)';
      this.tick();this.interval=setInterval(()=>this.tick(),1000);
    }
    tick() {
      const remaining=Math.max(0,Math.floor((this.deadline-Date.now())/1000));
      if(!remaining){this.hidden=true;clearInterval(this.interval);return;}
      this.hidden=false;
      const values={days:Math.floor(remaining/86400),hours:Math.floor(remaining%86400/3600),minutes:Math.floor(remaining%3600/60),seconds:remaining%60};
      for(const [unit,value] of Object.entries(values))this.querySelector('[data-'+unit+']').textContent=String(value).padStart(2,'0');
    }
    disconnectedCallback(){clearInterval(this.interval);}
  }
  if(!customElements.get('sx-sale-countdown'))customElements.define('sx-sale-countdown',SxSaleCountdown);
  const nativeButton=shareDialog.querySelector('[data-sx-native]');
  if(nativeButton)nativeButton.hidden=!navigator.share;
  items=read();render();
})();
